module.exports = __webpack_public_path__ + "static/media/mtruck.79eeb18d.svg";